import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHuluComponent } from './simple-icons-hulu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHuluComponent ],
    exports:      [ SimpleIconsHuluComponent ],
    bootstrap:    []
})
export class SimpleIconsHuluModule {}
